<div class="grid lg:grid-cols-4 md:grid-cols-2 gap-4 mb-7">
    <div *ngFor="let card of cards" class="flex flex-col justify-between p-6 rounded-lg"
        [ngStyle]="{ 'background-color': card?.bgColor }">
        <div class="mb-4">
            <h2 class="font-semibold text-[18px] leading-5 text-[#15191E] mb-1.5">{{ card?.title }}</h2>
            <p class="font-normal text-sm text-[#6B7080]">{{ card?.subtitle }}</p>
        </div>
        <div class="flex justify-between items-center gap-1 flex-wrap">
            <h3 class="font-semibold text-3xl text-[#15191E] leading-5">{{ card?.value }}<span *ngIf="card?.valueSuffix"
                    class="ms-1 font-normal text-sm text-[#6B7080]">{{ card?.valueSuffix }}</span>
            </h3>

            <p *ngIf="card?.changeValue" class="flex gap-1 items-center font-medium text-sm text-[#6B7080]">
                <span class="flex gap-1 items-center">
                    <img *ngIf="card?.changeIcon" [src]="'./assets/images/icons/employee/' + card?.changeIcon" alt="">
                    <span [ngStyle]="{ color: card?.changeColor }">{{ card?.changeValue }}</span>
                </span>
                {{ card?.compareText }}
            </p>
        </div>
    </div>
</div>